<template>
    <v-row>
        <v-col cols="12" class="pb-1">
            <v-divider class="mb-5"></v-divider>
            <div class="d-flex justify-space-between align-center">
                <span class="title">
                    <v-icon>group</v-icon>
                    {{ $t('contracts.form.part.title') }}
                </span>
                <contract-part-dialog :show.sync="partDialog.show" :setup.sync="setup" :contract.sync="contract" @close-part-dialog="reOrder"></contract-part-dialog>
            </div>
        </v-col>
        <v-col cols="12" v-if="contract.part.length < 1">
            <div class="text-center"><span style="color: red">{{ $t('contracts.form.part.empty') }}</span></div>
        </v-col>
        <v-col cols="12" class="pt-1 pb-1" v-else>
            <v-list dense>
                <template v-for="(item, index) in contract.part">
                    <v-card
                        :key="index"
                        v-if="!!item.isMainPart || viewAllParts"
                        class="contract-part-item mx-auto mb-1"
                        :class="{ main: item.isMainPart }"
                        outlined
                    >
                        <v-card-title class="headline pt-1">{{item.name}}</v-card-title>
                        <v-card-subtitle class="pb-1">{{item.type}} <span v-if="item.isMainPart"> - <strong>{{ $t('contracts.form.part.isMainPart') }}</strong></span></v-card-subtitle>
                        <v-card-actions class="pt-1 pb-1">
                            <v-spacer></v-spacer>
                            <v-btn
                                v-if="!item.isMainPart"
                                color="indigo"
                                dark
                                depressed
                                small
                                @click.prevent="setMainPart(item)"
                            >
                                {{ $t('contracts.form.part.setMainPart') }}
                            </v-btn>
                            <v-btn
                                color="error"
                                text
                                small
                                @click.prevent="deletePart(index, item)"
                            >
                                {{ $t('common.remove') }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </template>
            </v-list>
        </v-col>
        <v-col cols="12" v-if="contract.part.length > 1">
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                @click="toggleAllParts()"
                small
            >
                {{ viewAllParts ? $t('contracts.form.part.showOnlyMainPart') : $t('contracts.form.part.showAllParts') }}
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import ContractPartDialog from '@/components/contract/ContractPartDialog'

export default {
    name: 'contract-part',
    components: {
        ContractPartDialog
    },
    props: ['setup', 'contract'],
    data () {
        return {
            viewAllParts: false,
            partDialog: {
                show: false
            }
        }
    },
    methods: {
        toggleAllParts () {
            this.viewAllParts = !this.viewAllParts
            this.reOrder()
        },
        setMainPart (part) {
            window.getApp.refreshContracts = true
            this.contract.part.forEach(item => {
                item.isMainPart = false
            })
            part.isMainPart = !part.isMainPart
            this.reOrder()
        },
        reOrder () {
            this.contract.part.sort(function (a, b) {
                if (a.isMainPart > b.isMainPart) return -1
                if (a.isMainPart < b.isMainPart) return 1

                if (a.name.toLowerCase() < b.name.toLowerCase()) return -1
                if (a.name.toLowerCase() > b.name.toLowerCase()) return 1
            })
        },
        deletePart (index) {
            window.getApp.refreshContracts = true
            let isMainPart = this.contract.part[index].isMainPart
            if (this.contract.part[index].objectId) {
                this.contract.partRemoved.push(this.contract.part[index])
            }
            this.contract.part.splice(index, 1)
            if (isMainPart && this.contract.part.length > 0) {
                this.setMainPart(this.contract.part[0])
            }
            this.$forceUpdate()
        }
    }
}
</script>

<style lang="stylus" scoped>
    .contract-part-item.main
        border: thin solid rgba(63, 81, 181, 1)
</style>
